import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { deleteMcpServer } from '@/services/mcp-gateway';

export function useDeleteMcpServer() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: (serverId: string) => deleteMcpServer(serverId, orgId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['mcp-servers', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['mcp-connector-presets', orgId] });
      // Removing the catalog server also deletes members' connectors to it (cascade, backend-side).
      void queryClient.invalidateQueries({ queryKey: ['mcp-connectors', orgId] });
    },
  });
}
